export const GoogleMapApiConfig = 'AIzaSyDOUxKgXgucnzHwxeTQlofOj0c6WX8cHKE';